 var body = document.body;
 var sc = (function(){
	var scrollElement = 'scrollingElement' in document ? document.scrollingElement : document.documentElement;
	var scrollPoint,prePoint,flag;
	return function(){
		scrollPoint = scrollElement.scrollTop;
		flag = prePoint > scrollPoint ? true : false;
		prePoint = scrollPoint;
		return flag;
	}
})();

window.addEventListener("scroll",function(){
	if(sc()){
		body.classList.remove("scrl_down");
	}else{
		body.classList.add("scrl_down");
	}
});

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener');
  }
}

$(function(){

var body=$('body');
var scrTop = 1;

$(window).on('scroll',function(){
	scrTop = $(window).scrollTop();
	scrlClass();
});

function scrlClass(){
	if(scrTop < 30){
		if(!body.hasClass("scrl_top")) {
			body.addClass("scrl_top");
		}
		body.removeClass("scrl");
	}else if(scrTop>0){
		body.removeClass("scrl_top");
		if(!body.hasClass("scrl")) {
			body.addClass("scrl");
		}
	}else{
		if(body.hasClass("scrl")) {
			body.removeClass("scrl");
		}
	}
}


// Menu toggle
var $hassub = $('.hassub');
$hassub.on('click',function(){
  $hassub.not(this).removeClass('active');
  $(this).toggleClass('active');
});

$('#subnavBtn').on('click',function(){
  body.toggleClass('navopen');
});


$('#newsletterBtn').on('click',function(){
  $('#newsletter').toggleClass('active');
});
$('#newsletterclose').on('click',function(){
  $('#newsletter').removeClass('active');
});


if( document.getElementById('top') ){
	var audioOn = $('#audioOn'),
	audioOff = $('#audioOff'),
	audioWrap = $('#audio_wrap'),
	audio = document.getElementById('audio');

	audio.addEventListener("play", function(){
		audioWrap.addClass('play');
	}, false);

	audioOn.on('click', function () {
		audio.play();
		audioWrap.addClass('play');
	});
	audioOff.on('click', function () {
		audio.pause();
		audioWrap.removeClass('play');
	});

}

if( document.getElementById('shopify-section-cart-template') ){
	$('.andd-multiple-orders a').addClass('Button Button--primary');
}

function imageSlide() {
  const swiper = new Swiper('.top_slideshow', {
    slidesPerView: 1,
    speed: 800,
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
}
imageSlide();

});

// Protect add-to-cart buttons with data-skip-js-update attribute from being replaced
(function() {
  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.removedNodes.forEach(function(removedNode) {
          if (removedNode.nodeType === 1 && 
              removedNode.classList && 
              removedNode.classList.contains('ProductForm__AddToCart') && 
              removedNode.hasAttribute('data-skip-js-update')) {
            // Button with skip attribute was removed, restore it
            var parent = mutation.nextSibling ? mutation.nextSibling.parentNode : mutation.target;
            if (parent && parent.querySelector('.ProductForm__AddToCart:not([data-skip-js-update])')) {
              var newButton = parent.querySelector('.ProductForm__AddToCart:not([data-skip-js-update])');
              newButton.replaceWith(removedNode);
            }
          }
        });
      });
    });
    
    var productForms = document.querySelectorAll('.ProductForm');
    productForms.forEach(function(form) {
      observer.observe(form, { childList: true, subtree: true });
    });
  }
})();





